module.exports = __webpack_public_path__ + "img/dsci0105.eace5ed9.jpg";